import { useFormContext } from "react-hook-form";
import useFormPersist from "react-hook-form-persist";

import { IProps } from "../../types/types";
import styles from "../../styles/CheckboxField.module.scss";

export const CheckboxField = ({ name, label, required, component }: IProps) => {
  const { register, trigger, watch, setValue } = useFormContext();
  useFormPersist("onboarding", { watch, setValue, storage: window.localStorage });

  return (
    <div className={styles.formItem}>
      <section style={{ marginBottom: "1.5rem" }}>
        <span>{label}</span>
      </section>
      <div className={styles.wrapper}>
        {component.options?.map((option) => (
          <div key={option} className={styles.options}>
            <input
              id={name}
              type={component.type}
              value={option}
              {...register(name.length > 100 ? name.slice(0, 100) : name, { required: required })}
              onKeyUp={() => {
                trigger(name);
              }}
            />
            <label htmlFor={name}>{option}</label>
          </div>
        ))}
      </div>
    </div>
  );
};
